<script setup lang="ts">
// Vue
import { computed, watch, onMounted } from "vue";

// Data Providers
import { useCalculationTypes } from "@/dataProviders/CalculationTypes";

// GraphQL
import { useGetCalculationTypeLazyQuery, Country_Enum } from "@/graphql";

// Components
import GraphQLError from "@/features/GraphQLError";

// ///////////////////
// Props
// ///////////////////

const props = defineProps<{
  country: Country_Enum | null;
}>();

// ///////////////////
// Data Providers
// ///////////////////

const calculationTypes = useCalculationTypes();

// ///////////////////
// Variables
// ///////////////////

const queryVariables = computed(() => ({
  country: props.country as Country_Enum,
}));

// ///////////////////
// Query
// ///////////////////

const { result, loading, error, refetch, load } = useGetCalculationTypeLazyQuery(
  props.country ? queryVariables.value : { country: Country_Enum.DENMARK }
);

// ///////////////////
// Lifecycle
// ///////////////////

onMounted(() => {
  load();
});

// ///////////////////
// Watchers
// ///////////////////

watch(
  () => props.country,
  (newValue) => {
    if (newValue) {
      refetch(queryVariables.value);
    }
  }
);

watch(
  result,
  (newValue) => {
    if (newValue) {
      calculationTypes.mapData(newValue);
    }
  },
  { deep: true }
);

watch(loading, (newLoading) => {
  calculationTypes.setLoading(newLoading);
});
</script>

<template>
  <GraphQLError
    :error="error"
    name="CalculationTypes" />
</template>
